export const printPdfInHiddenIframe = (blobUrl, { delay = 500 } = {}) => {
  const iframe = document.createElement("iframe");
  let cleaned = false;

  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    setTimeout(() => {
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
      URL.revokeObjectURL(blobUrl);
    }, 300);
  };

  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  iframe.style.visibility = "hidden";
  iframe.src = blobUrl;

  iframe.onload = () => {
    setTimeout(() => {
      try {
        const printWindow = iframe.contentWindow;
        if (!printWindow) {
          cleanup();
          return;
        }

        printWindow.focus();
        printWindow.onafterprint = cleanup;
        printWindow.print();
      } catch (error) {
        console.error("Unable to trigger print dialog:", error);
        cleanup();
      }
    }, delay);
  };

  document.body.appendChild(iframe);
};
